export const sort = (arr: any[], method: (a: any, b: any) => any) => {
    return [...arr].sort(method)
}
